var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-head',{attrs:{"headData":_vm.componentData}}),_c(_vm.componentId,{tag:"component"}),_c('v-foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }